export const EXPORT_SHOW_UPSELL_DIALOG = 'EXPORT_SHOW_UPSELL_DIALOG'

export const SHOW_UPSELL_DIALOG_ID = 'portfolio_export_upsell'

export const LOCALE_PREFIX = 'scenes.Gnosus.scenes.Portfolio.components.Toolbar.components.ToolbarDesks.Exports'
